// extracted by mini-css-extract-plugin
export default {"planConnector":"QuotaInsurancePlanStep_planConnector__KdzSq","planConnectorIcon":"QuotaInsurancePlanStep_planConnectorIcon__x+z4k"};